import React, { useState, useEffect } from 'react';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function SqlToJson() {
  const [sql, setSql] = useState('SELECT id, name, email FROM users WHERE id = 1;');
  const [json, setJson] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!sql.trim()) {
      setJson('');
      return;
    }

    try {
      // This is a very basic parser for demo purposes.
      const match = sql.trim().match(/^SELECT\s+(.+?)\s+FROM\s+([a-zA-Z0-9_]+)/i);
      if (!match) {
        throw new Error('Only simple SELECT statements are supported (e.g., SELECT col1, col2 FROM table).');
      }

      const columns = match[1].split(',').map(c => c.trim());

      // Create dummy data for demonstration
      const dummyData = Array.from({ length: 3 }, (_, i) => {
        const row = {};
        columns.forEach(col => {
          if (col === '*') {
            row['id'] = i + 1;
            row['name'] = `User ${i + 1}`;
            row['email'] = `user${i + 1}@example.com`;
          } else {
            row[col] = `${col}_value_${i + 1}`;
          }
        });
        return row;
      });

      setJson(JSON.stringify(dummyData, null, 2));
    } catch (e) {
      setError(e.message);
      setJson('');
    }
  };

  const handleClear = () => {
    setSql('');
    setJson('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="SQL to JSON Converter | Free Online Demo | UmbrellaCo"
        description="Convert SQL table structures and data to JSON. An interactive online tool to demonstrate mapping relational databases to NoSQL JSON objects."
        keywords="sql to json, convert sql to json online, sql parser to json, online json tools"
        url="/json-tools/sql-to-json"
        jsonLd={createSoftwareAppSchema(
          'SQL to JSON Converter',
          'Convert SQL queries into JSON structures.',
          'https://umbrellaco.in/json-tools/sql-to-json',
          ['SQL Parsing', 'JSON Formatting', 'Data Transformation Demo']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
          title="SQL to JSON Converter"
          description="Demo tool to parse a simple SQL SELECT statement and generate a representative JSON array."
        leftTitle="SQL"
        rightTitle="JSON"
        leftLanguage="sql"
        rightLanguage="json"
        leftValue={sql}
        setLeftValue={setSql}
        rightValue={json}
        onConvert={handleConvert}
        onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default SqlToJson;